import type {Emoji} from '@github-ui/markdown-editor'
import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'
import {useQuery} from '@github-ui/react-query'

type StatusEmojiResponse = {
  name: string
  aliases: string[]
  tags: string[]
  category: string | null
  image_filename: string
  image_url: string
  unicode_aliases: string[]
}

/**
 * Fetches status emojis for user status dialog.
 * @returns Query result with formatted status emojis
 */
export function useStatusEmojiQuery() {
  return useQuery({
    queryKey: ['user-status-emojis-for-status-dialog'] as const,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: Infinity, // Emoji data is static, no need to refetch
    queryFn: () =>
      queryFnFetch<StatusEmojiResponse[]>({
        queryDeps: {pathname: '/users/status/emoji.json'},
      }),
    select: (data: StatusEmojiResponse[]): Emoji[] =>
      data.map((emoji: StatusEmojiResponse) => {
        // If there's a unicode representation, use it
        if (emoji.unicode_aliases.length > 0) {
          return {
            name: emoji.name,
            character: emoji.unicode_aliases[0],
            url: emoji.image_url,
          }
        }
        // Otherwise, it's a custom emoji with just an image URL
        return {
          name: emoji.name,
          url: emoji.image_url,
        }
      }),
  })
}
